import React, { useState, useEffect } from "react";
import { SlidingSidePanel } from "../../../_common/SlidingSidePanel";
import * as Api from "../../../../Api";
import { Notify } from "../../../../services/Notify.service";
import { ShareFileWithVendorAndAttroney } from "./ShareFileWithVendorAndAttorney";

export const SelectVendor = ({
  claimId,
  showShareVendorUI,
  setShowShareVendorUI,
  shareClaimToken,
  shareLink,
  isSharedView,
}) => {
  const [selectedVendor, setSelectedVendor] = useState([]);
  const [selectedAttorney, setSelectedAttorney] = useState([]);
  const [allVendors, setAllVendors] = useState([]);
  const [showSelectedUsersScreen, setShowSelectedUsersScreen] = useState(false);

  const goToNextLevel = () => {
    if (selectedVendor.length === 0 && selectedAttorney.length === 0) {
      Notify.error("Please select Attorney/Vendor List. ");
      return false;
    }
    setShowShareVendorUI(false);
    setShowSelectedUsersScreen(true);
  };

  const fetchAllVendors = () => {
    Api.Claims.Vendors.get()
      .then((data) => {
        setAllVendors(data.data.vendors);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const selectVendorForSharingClaim = (vendor) => {
    const currentSelected = [...selectedVendor];
    const index = selectedVendor.find((x) => x.id === vendor.id);
    if (!index) {
      currentSelected.push(vendor);
      setSelectedVendor(currentSelected);
    }
    if (index) {
      const newSelected = currentSelected.filter((x) => x.id !== vendor.id);
      setSelectedVendor(newSelected);
    }
  };

  useEffect(() => {
    if (!isSharedView) {
      fetchAllVendors();
    }
  }, [isSharedView]);

  return (
    <>
      {showShareVendorUI && (
        <SlidingSidePanel type={"right"} isOpen={showShareVendorUI}>
          <div className="portlet light">
            <div className="portlet-title">
              <div className="caption">
                <span className="caption-subject bold uppercase">
                  Share File With Vendors
                </span>
              </div>
              <div className="tools">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setShowShareVendorUI(false);
                  }}
                  href="#!"
                  className="remove"
                  data-original-title=""
                  title=""
                >
                  &nbsp;
                </a>
              </div>
            </div>
            <div className="portlet-body">
              <div className="tabbable-custom nav-justified">
                <div
                  className="tab-content client-edit-mid-tab-content"
                  style={{ border: "1px transparent" }}
                >
                  <div className="tab-pane active" style={{ minHeight: "90vh" }}>
                    <div className="alert alert-info">
                      <strong>Step 1 - Choose who to Share with. </strong>You
                      can select one or more Vendors to share the file with.
                    </div>
                    <div className="mt-element-list">
                      <div
                        className="mt-list-container list-default"
                        style={{ borderColor: "#ffffff" }}
                      >
                        <div className="mt-list-title uppercase">
                          Choose Vendors
                        </div>

                        {allVendors.length > 0 && (
                          <ul className="ven_share">
                            {allVendors.map((v) => {
                              return (
                                <li
                                  className="mt-list-item"
                                  key={v.id}
                                  onClick={(event) => {
                                    selectVendorForSharingClaim(v);
                                  }}
                                >
                                  <div
                                    className={
                                      selectedVendor.find((x) => x.id === v.id)
                                        ? `list-icon-container done`
                                        : `list-icon-container`
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <a href="#!">
                                      <i className="fa fa-check-circle"></i>
                                    </a>
                                  </div>
                                  <div className="list-item-content">
                                    <h3 className="uppercase bold">
                                      <a href="#!">{v.name}</a>
                                    </h3>
                                    <p className="email_pra">
                                      {v.email ? v.email : <br />}
                                    </p>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row"
                style={{
                  position: "sticky",
                  bottom: 0,
                  background: "#e1e5eb",
                  paddingTop: 20,
                  paddingBottom: 20,
                  opacity: 0.8,
                }}
              >
                <div className="col-sm-6">
                  <button
                    type="button"
                    onClick={() => goToNextLevel()}
                    className="btn btn-primary mt-ladda-btn ladda-button btn-block btn-lg purple-soft next_share_all_vendor_btn_cls"
                  >
                    NEXT
                  </button>
                </div>
                <div className="col-sm-6">
                  <button
                    type="button"
                    className="btn btn-lg white btn-block"
                    onClick={() => setShowShareVendorUI(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </SlidingSidePanel>
      )}
      <ShareFileWithVendorAndAttroney
        claimId={claimId}
        showSelectedUsersScreen={showSelectedUsersScreen}
        setShowSelectedUsersScreen={setShowSelectedUsersScreen}
        selectedVendors={selectedVendor}
        selectedAttorney={selectedAttorney}
        shareClaimToken={shareClaimToken}
        shareLink={shareLink}
        setSelectedVendor={setSelectedVendor}
        setSelectedAttorney={setSelectedAttorney}
      />
    </>
  );
};
